import Vue from 'vue'
import Router from 'vue-router'
import Index from 'components/Index'
import EvaluationOne from 'components/Evaluation/One'
import EvaluationQuestion from 'components/Evaluation/Question'
import lastlow from 'components/Evaluation/lastLow'
import lastlowend from 'components/Evaluation/lastLowEnd'
import batchlow from 'components/Evaluation/batchLow'
import normal from 'components/Evaluation/normal'

// 投资者信息表-机构
import AgencyOne from 'components/InvestorInfo/Agency/One'
import AgencyTwo from 'components/InvestorInfo/Agency/Two'
import AgencyThree from 'components/InvestorInfo/Agency/Three'
import AgencyFour from 'components/InvestorInfo/Agency/Question'
// 投资者信息表-个人
import PersonalOne from 'components/InvestorInfo/Personal/One'
import PersonalQuestion from 'components/InvestorInfo/Personal/Question'
// 机构产品买产品
import ProductOne from 'components/InvestorInfo/Product/One'
import ProductTwo from 'components/InvestorInfo/Product/Two'
import ProductThree from 'components/InvestorInfo/Product/Three'
import ProductFour from 'components/InvestorInfo/Product/Question'
// 分享
import ShareIndex from 'components/Share/Index'
import ShareOne from 'components/Share/page/one'
import ShareTwo from 'components/Share/page/two'
import ShareThree from 'components/Share/page/three'
import ShareFour from 'components/Share/page/four'
import ShareFive from 'components/Share/page/five'
import ShareSix from 'components/Share/page/six'
import ShareSeven from 'components/Share/page/seven'
import ShareEight from 'components/Share/page/eight'
import Relation from 'components/Relation'

import Download from 'components/Download'
import DownloadDemo from 'components/DownloadDemo'

import GuideList from 'components/Guide/guideList'
import GuideRegister from 'components/Guide/registerGuide'
import GuideConfirmList from 'components/Guide/Confirm/confirmListGuide'
import GuideAppStep from 'components/Guide/appointmentStepGuide'
import GuideAppConfStep from 'components/Guide/appointmentConfStepGuide'
import GuideContractStep from 'components/Guide/contractStepGuide'
import GuideInvite from 'components/Guide/inviteGuide'
import GuideConfirm from 'components/Guide/confirmGuide'
import GuideRisk from 'components/Guide/riskGuide'
import GuideAppointment from 'components/Guide/appointmentGuide'
import GuideCreateProduct from 'components/Guide/createProductGuide'
import GuideRecord from 'components/Guide/recordGuide'
import GuideContract from 'components/Guide/contractGuide'
import GuideOrderState from 'components/Guide/orderStateGuide'
import GuideFindPwd from 'components/Guide/findPwdGuide'

import PerNormalConfirm from 'components/Guide/Confirm/perNormalConfirm'
import PerEmpConfirm from 'components/Guide/Confirm/perEmpConfirm'
import PerProConfirm from 'components/Guide/Confirm/perProConfirm'
import OrgNormalConfirm from 'components/Guide/Confirm/orgNorConfirm'
import OrgSelfConfirm from 'components/Guide/Confirm/orgSelfConfirm'
import OrgProConfirm from 'components/Guide/Confirm/orgProConfirm'
import OrgFinConfirm from 'components/Guide/Confirm/orgFinConfirm'

import agreeupdate from 'components/AgreeUpdate/index'
Vue.use(Router)
const Routes = [
  {path: '/', component: Index, meta: {title: '首页'}},
  {path: '/evaluation/one', component: EvaluationOne, meta: {title: '风险测评问卷'}},
  {path: '/evaluation/question', component: EvaluationQuestion, meta: {title: '风险测评问卷'}},
  {path: '/evaluation/lastlow', component: lastlow, meta: {title: '最低风险承受能力选择'}},
  {path: '/evaluation/lastlowend', component: lastlowend, meta: {title: '风险承受等级'}},
  {path: '/evaluation/batchlow', component: batchlow, meta: {title: '最低风险承受能力选择'}},
  {path: '/evaluation/normal', component: normal, meta: {title: '风险承受等级'}},
  {path: '/investor/agency/one', component: AgencyOne, meta: {title: '投资者信息表'}},
  {path: '/investor/agency/two', component: AgencyTwo, meta: {title: '投资者信息表'}},
  {path: '/investor/agency/three', component: AgencyThree, meta: {title: '投资者信息表'}},
  {path: '/investor/agency/four', component: AgencyFour, meta: {title: '投资者信息表'}},
  {path: '/investor/personal/one', component: PersonalOne, meta: {title: '投资者信息表'}},
  {path: '/investor/personal/question', component: PersonalQuestion, meta: {title: '投资者信息表'}},
  {path: '/investor/product/one', component: ProductOne, meta: {title: '投资者信息表'}},
  {path: '/investor/product/two', component: ProductTwo, meta: {title: '投资者信息表'}},
  {path: '/investor/product/three', component: ProductThree, meta: {title: '投资者信息表'}},
  {path: '/investor/product/four', component: ProductFour, meta: {title: '投资者信息表'}},
  {path: '/share/index', component: ShareIndex, meta: {title: '特定对象认证'}},
  {path: '/share/one', component: ShareOne, meta: {title: '特定对象认证'}},
  {path: '/share/two', component: ShareTwo, meta: {title: '特定对象认证'}},
  {path: '/share/three', component: ShareThree, meta: {title: '特定对象认证'}},
  {path: '/share/four', component: ShareFour, meta: {title: '特定对象认证'}},
  {path: '/share/five', component: ShareFive, meta: {title: '特定对象认证'}},
  {path: '/share/six', component: ShareSix, meta: {title: '特定对象认证'}},
  {path: '/share/seven', component: ShareSeven, meta: {title: '特定对象认证'}},
  {path: '/share/eight', component: ShareEight, meta: {title: '特定对象认证'}},
  {path: '/relation', component: Relation, meta: {title: '投资者关联'}},

  {path: '/download', component: Download, meta: {title: 'App下载'}},
  {path: '/downloadDemo', component: DownloadDemo, meta: {title: 'App下载'}},
  {path: '/guide/list', component: GuideList, meta: {title: '投资者APP操作手册'}},
  {path: '/guide/register', component: GuideRegister, meta: {title: '账户注册流程'}},
  {path: '/guide/confirmList', component: GuideConfirmList, meta: {title: '特定对象确认流程'}},
  {path: '/guide/appointmentStep', component: GuideAppStep, meta: {title: '预约申请流程'}},
  {path: '/guide/appointmentConStep', component: GuideAppConfStep, meta: {title: '预约确认流程'}},
  {path: '/guide/contractStep', component: GuideContractStep, meta: {title: '合同签署流程说明'}},
  {path: '/guide/invite', component: GuideInvite, meta: {title: '邀请码关联'}},
  {path: '/guide/confirm', component: GuideConfirm, meta: {title: '身份认证'}},
  {path: '/guide/risk', component: GuideRisk, meta: {title: '风险承受能力测评'}},
  {path: '/guide/appointment', component: GuideAppointment, meta: {title: '预约申请'}},
  {path: '/guide/createProduct', component: GuideCreateProduct, meta: {title: '创建产品（产品买产品）'}},
  {path: '/guide/record', component: GuideRecord, meta: {title: '双录'}},
  {path: '/guide/contract', component: GuideContract, meta: {title: '合同签署'}},
  {path: '/guide/orderState', component: GuideOrderState, meta: {title: '订单状态说明'}},
  {path: '/guide/findPwd', component: GuideFindPwd, meta: {title: '如何找回密码'}},
  {path: '/guide/confirm/perNor', component: PerNormalConfirm, meta: {title: '普通投资者自然人'}},
  {path: '/guide/confirm/perPro', component: PerProConfirm, meta: {title: '专业投资者自然人'}},
  {path: '/guide/confirm/perEmp', component: PerEmpConfirm, meta: {title: '员工跟股'}},
  {path: '/guide/confirm/orgNor', component: OrgNormalConfirm, meta: {title: '普通投资者机构'}},
  {path: '/guide/confirm/orgPro', component: OrgProConfirm, meta: {title: '专业投资者机构'}},
  {path: '/guide/confirm/orgSelf', component: OrgSelfConfirm, meta: {title: '本机构'}},
  {path: '/guide/confirm/orgFin', component: OrgFinConfirm, meta: {title: '金融机构'}},

  // 服务协议及隐私变更通知
  {path: '/agreeupdate/index', name: 'agreeupdate', component: agreeupdate, meta: {title: '服务协议及隐私变更通知'}}
]

export default new Router({
  mode: 'history',
  routes: Routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js